import './App.css';
import { Container, Navbar } from "react-bootstrap"
import { Home, CompareDevices, ProudctsList, ProductDetails, AboutUs, ContactPage, BrandsPage, ServicesList, OopsPage } from './Pages';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Footer, NavigationBar } from './Layouts';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import loadingGif from '../src/assets/Images/gif/loading.gif';
// import fav_logo from './assets/Images/home/filtrix_fav.png';
import fav_logo from './assets/Images/home/fav_filtrix.webp';



function WesiteLayout({ url, children, loading, dataFooter }) {
  const location = useLocation();

  useEffect(() => {
    const updateFavicon = () => {
      let link = document.querySelector('link[rel="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = fav_logo;
    };

    updateFavicon();
  }, []);

  if (loading) {
    return (
      <div id="preloader">
        <div class="preloader1"></div>
      </div>
    );
  }

  return (
    <>
      <NavigationBar />
      {children}
      <Footer dataFooter={dataFooter} />
    </>
  );
}

function App() {
  const url = 'https://filtrix-backend.inter-netsys.com';     //'https://filtrix.gbh.ae';
  const [data, setData] = useState([]);
  const [dataFooter, setDataFooter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageTitle, setPageTile] = useState([]);

  const pageUrl = window.location.pathname;
  let pageName;




  useEffect(() => {

    if ((pageUrl.lastIndexOf("/") === -1) || (pageUrl.lastIndexOf("/") === pageUrl.length - 1)) {
      pageName = "home";
    } else {
      pageName = pageUrl.substr(pageUrl.lastIndexOf("/") + 1);
    }
    fetchWebsiteData(pageName);
    
  }, [pageUrl]);

  useEffect(() => {
    document.title = `Filtrix | ${pageTitle}`;
  }, [pageTitle]);

  const fetchWebsiteData = async (pageName) => {
    setLoading(true);
    // const apiKey = Cookies.get('api_key');
    // const apiSecret = Cookies.get('api_secret');
    var headers = { 'Content-Type': 'application/json', };

    // if (apiKey == null && apiSecret == null) {
    //   clearCookies();
    // } else {
    //   headers["Authorization"] = `token ${apiKey}:${apiSecret}`;
    // }

    try {
      const response = await axios.get(
        `${url}/api/method/filtrix.filtrix.doctype.pages.pages.page?name=${pageName}`,
        { headers: headers }
      );

      // if (response?.data?.result?.is_active === false) {
      //   clearCookies();
      // }

      // console.log("API Response:", response.data);
      setData(
        pageName === "products" || pageName === "brands" || pageName === "services"
          ? response?.data?.result
          : response?.data?.result?.content?.templates || []
      );
      setPageTile(response?.data?.result?.page_title || "");
      const footerData = response?.data?.result?.footer || [];

      setDataFooter(footerData);


    
        setLoading(false);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  return (
    <div className="App">

      {
        !error ? (
          <WesiteLayout url={url} loading={loading} dataFooter={dataFooter}>
            <Routes>
              <Route index element={<Home url={url} data={data} loading={loading} />} />
              <Route path="/home" element={<Home url={url} data={data} loading={loading} />} />
              <Route path='/CompareDevices' element={<CompareDevices url={url} data={data} />} />
              <Route path='/products' element={<ProudctsList url={url} data={data} />} />
              <Route path='/about' element={<AboutUs url={url} data={data} />} />
              <Route path='/productdetails' element={<ProductDetails url={url} />} />
              <Route path='/services' element={<ServicesList url={url} data={data} />} />
              <Route path='/contact' element={<ContactPage url={url} data={data} />} />
              <Route path='/brands' element={<BrandsPage url={url} data={data} />} />
            </Routes>
          </WesiteLayout>

        ) :
          < OopsPage />
      }

    </div>
  );
}

export default App;
